var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 1,
    width: 23,
    height: 23,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 1,
    width: 23,
    height: 23,
    rx: 5.5,
    stroke: "#008E72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76995 15.6092L5.93262 19.2999L9.62328 18.4626L6.76995 15.6092ZM13.8206 8.47324L7.21795 15.0706L10.162 18.0146L16.7593 11.4119L13.8206 8.47324ZM15.794 6.49991L14.3113 7.98258L17.2499 10.9212L18.7326 9.43858L15.794 6.49991Z",
    fill: "#008E72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.b4fc3b309949fff5a39d361b4444d975.svg";
export { ForwardRef as ReactComponent };